import {
  PROMPT_CATEGORIES as DRAWER_PROMPT_CATEGORIES,
  STARTER_PROMPTS as DRAWER_STARTER_PROMPTS,
} from "connected-components/ai-teammate/helpers/constants"

// Single source of truth: the drawer's canonical prompts (APP-3404). Kelly consumes the text only;
// the classification set (SUGGESTED_PROMPT_TEXTS) derives from these same lists so the two never drift.
export const STARTER_PROMPTS = DRAWER_STARTER_PROMPTS.map((prompt) => prompt.text)

// "Browse topics" categories, reshaped to Kelly's text-only shape (theme keys the accordion; label is the chip).
export const PROMPT_CATEGORIES = DRAWER_PROMPT_CATEGORIES.map((category) => ({
  theme: category.theme,
  label: category.label,
  prompts: category.prompts.map((prompt) => prompt.text),
}))

// Every suggested-prompt text (starters + category prompts): send-source analytics classify these as "suggested".
export const SUGGESTED_PROMPT_TEXTS = [
  ...STARTER_PROMPTS,
  ...PROMPT_CATEGORIES.flatMap((category) => category.prompts),
]

/**
 * The drawer's `{ id, theme }` for a prompt text. Kelly's lists stay text-only — the alternative was carrying
 * the objects through the empty state, four story files and two suites for the sake of two payload fields.
 * Keyed on text because text is already this feature's prompt identity (SUGGESTED_PROMPT_TEXTS classifies
 * sends the same way), and both sides derive from the same canonical lists, so they cannot drift.
 */
const PROMPT_META_BY_TEXT = new Map(
  [...DRAWER_STARTER_PROMPTS, ...DRAWER_PROMPT_CATEGORIES.flatMap((category) => category.prompts)]
    .map((prompt) => [prompt.text, { prompt_id: prompt.id, theme: prompt.theme }]),
)

/** Analytics identity for a suggested prompt, or null for text that is not one. */
export function getPromptMeta(text) {
  return PROMPT_META_BY_TEXT.get(text) ?? null
}
